import { usePageTitle } from '@/composables';

export default async to => {
  // TODO temporary fix for route name not updating when navigating to home page after viewing an event
  usePageTitle().setTitle('Sportpix');

  setTimeout(() => {
    const pageTitle = to.params.slug
      ? to.params.slug.replace(/-/g, ' ').replace(/\b\w/g, char => char.toUpperCase())
      : to.meta.title;

    usePageTitle().setTitle(pageTitle);
  }, 5);
};
